import { Space, Typography } from "antd";
import UsersIcon from "~/components/icons/UsersIcon";

const { Text } = Typography;

const GroupMemberCount = ({ group }) => {
  return (
    <Text type="secondary">
      <Space size={3}>
        <UsersIcon />
        {group.member_count}
      </Space>
    </Text>
  )
}

export default GroupMemberCount;
